import React from 'react';

interface AvatarProps {
  name?: string;
  lastName?: string;
  sizeRem?: number;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ name, lastName, sizeRem = 3, className }) => {
  const getInitial = (s?: string) => (s && s.trim().length > 0 ? s.trim().charAt(0).toUpperCase() : '');
  const first = getInitial(name);
  let second = getInitial(lastName);
  if (!second && name && name.trim().includes(' ')) {
    const parts = name.trim().split(/\s+/);
    second = getInitial(parts[1]);
  }
  const initials = (first + second) || first || second || 'P';

  const style: React.CSSProperties = {
    width: `${sizeRem}rem`,
    height: `${sizeRem}rem`,
    borderRadius: '9999px',
    background: '#ebe9f5',
    border: '3px solid #b8b4e0',
    color: '#6155d8',
    display: 'flex',
    paddingTop: "1px",
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500,
    fontSize: `${Math.max(1, sizeRem * 0.4)}rem`
  };

  return (
    <div className={className} style={style} aria-label="avatar-initial">
      {initials}
    </div>
  );
};

export default Avatar;


